<p-confirmDialog></p-confirmDialog>
<form [formGroup]="customerAdminForm" autocomplete="off">
  <div class="grid">
    <ng-container>
      <!-- Email  -->
      <div class="col-12 md:col-6 lg:col-4 form-group">
        <div class="form-group">
          <ng-container *ngIf="operation !== 'view'">
            <ng-container *ngIf="loading; else EmailTemplate">
              <app-skeleton id="label-input-items"></app-skeleton>
            </ng-container>
            <ng-template #EmailTemplate>
              <div class="flex flex-column gap-1">
                <label for="username">Email<span class="text-red-500">*</span></label>
                <input pInputText type="text" formControlName="email" placeholder="Enter Email"
                  (input)="validateEmail($event)" name="email" required maxlength="50">
                <small class="text-red-500"
                  *ngIf="customerAdminForm.get('email')?.touched && !customerAdminForm.get('email')?.value">*Email is
                  required.</small>
                <small class="text-red-500" *ngIf="customerAdminForm.get('email')?.value && !isEmailValid">*Invalid
                  Email
                  Format.</small>
                <small class="text-red-500" *ngIf="customerAdminForm.get('email')?.hasError('forbiddenCharacters')">
                  Email
                  should not contain percentage (%), or plus (+).
                </small>
                <small class="text-red-500" *ngIf="customerAdminForm.get('email')?.hasError('leadingOrTrailingSpaces')">
                  Email should not contain leading or trailing spaces.
                </small>
                <small class="text-red-500"
                  *ngIf="customerAdminForm.get('email')?.hasError('multipleSpecialCharacters')">
                  Email should not contain consecutive underscores (_) or hyphens (-).
                </small>
              </div>
            </ng-template>
          </ng-container>

          <p-card class="card-border" *ngIf="operation === 'view'">
            @if(loading){
            <app-skeleton [id]="'label-input-items'"></app-skeleton>
            } @else{
            <label for="">Email</label>
            <h3 class="m-0 font-medium">{{customerDetails?.email_id? customerDetails.email_id: '-' }}</h3>
            }
          </p-card>

        </div>
      </div>
    </ng-container>
    <!-- first name  -->
    <ng-container>
      <div class="col-12 md:col-6 lg:col-4 form-group">
        <div class="form-group ">
          <ng-container *ngIf="operation !== 'view'">
            <ng-container *ngIf="loading; else firstnameTemplate">
              <app-skeleton id="label-input-items"></app-skeleton>
            </ng-container>
            <ng-template #firstnameTemplate>
              <div class="flex flex-column gap-1">
                <label for="">First Name<span class="text-red-500">*</span></label>
                <input pInputText type="text" (keypress)="onlyAlphabet($event)" maxlength="25"
                  (paste)="onPaste($event,'firstName')" formControlName="firstName" placeholder="Enter First Name"
                  name="firstName" required>
                <small class="text-red-500"
                  *ngIf="customerAdminForm.get('firstName')?.touched && !customerAdminForm.get('firstName')?.value">*First
                  Name is required.</small>
              </div>
            </ng-template>
          </ng-container>
          <p-card class="card-border" *ngIf="operation === 'view'">
            @if(loading){
            <app-skeleton [id]="'label-input-items'"></app-skeleton>
            } @else{
            <label for="">First Name</label>
            <h3 class="m-0 font-medium">{{customerDetails?.first_name?
              customerDetails.first_name: '-'}}</h3>
            }
          </p-card>
        </div>
      </div>
    </ng-container>
    <!-- last name  -->
    <ng-container>
      <div class="col-12 md:col-6 lg:col-4 form-group">
        <ng-container *ngIf="operation !== 'view'">
          <ng-container *ngIf="loading; else lastnameTemplate">
            <app-skeleton id="label-input-items"></app-skeleton>
          </ng-container>
          <ng-template #lastnameTemplate>
            <div class="flex flex-column gap-1">
              <label for="">Last Name<span class="text-red-500">*</span></label>
              <input pInputText type="text" (keypress)="onlyAlphabet($event)" maxlength="25"
                (paste)="onPaste($event,'lastName')" formControlName="lastName" placeholder="Enter Last Name"
                name="lastName">
              <small class="text-red-500"
                *ngIf="customerAdminForm.get('lastName')?.touched && !customerAdminForm.get('lastName')?.value">*Last
                Name
                is required.</small>
            </div>
          </ng-template>
        </ng-container>
        <p-card class="card-border" *ngIf="operation === 'view'">
          @if(loading){
          <app-skeleton [id]="'label-input-items'"></app-skeleton>
          } @else{
          <label for="">Last Name</label>
          <h3 class="m-0 font-medium">{{customerDetails?.last_name? customerDetails.last_name:
            '-'}}</h3>
          }
        </p-card>
      </div>
    </ng-container>
    <!-- primary phone number  -->
    <ng-container>
      <div class="col-12 md:col-6 lg:col-4 form-group">
        <ng-container *ngIf="operation !== 'view'">
          <ng-container *ngIf="loading; else contactTemplate">
            <app-skeleton id="label-input-items"></app-skeleton>
          </ng-container>
          <ng-template #contactTemplate>
            <div class="flex flex-column gap-1">
              <label for="PrimaryContactNumber">Contact Number<span class="text-red-500">*</span></label>
              <app-custom-phone-number [customPhoneForm]="customPhoneForm" [isCustomer]="true"
                [requiredErrorMessage]="'*Contact Number is required.'"
                (countryChange)="onCountryChange($event)"></app-custom-phone-number>
            </div>
          </ng-template>
        </ng-container>
        <p-card class="card-border" *ngIf="operation === 'view'">
          @if(loading){
          <app-skeleton [id]="'label-input-items'"></app-skeleton>
          } @else{
          <label for="">Contact Number</label>
          <h3 class="m-0 font-medium">{{ customerDetails?.mobile_number ? customPhoneForm.get('country')?.value?.dial_code +" "+
            customPhoneForm.get('phoneNumber')?.value : '-'}}</h3>
          }
        </p-card>
      </div>
    </ng-container>
    <!-- user name  -->
    <ng-container>
      <div class="col-12 md:col-6 lg:col-4 form-group">
        <ng-container *ngIf="operation !== 'view'">
          <ng-container *ngIf="loading; else UserTemplate">
            <app-skeleton id="label-input-items"></app-skeleton>
          </ng-container>
          <ng-template #UserTemplate>
            <div class="flex flex-column gap-1">
              <label for="">User Name<span class="text-red-500">*</span></label>
              <input pInputText type="text" (keypress)="onlyLowerCaseAlphabet($event)" maxlength="25"
                (paste)="onPaste($event,'username')" formControlName="username" placeholder="Enter User Name"
                name="username" required>
              <small class="text-red-500"
                *ngIf="customerAdminForm.get('username')?.touched && !customerAdminForm.get('username')?.value">*User
                Name
                is required.</small>
            </div>
          </ng-template>
        </ng-container>
        <p-card class="card-border" *ngIf="operation === 'view'">
          @if(loading){
          <app-skeleton [id]="'label-input-items'"></app-skeleton>
          } @else{
          <label for="">User Name</label>
          <h3 class="m-0 font-medium">{{customerDetails?.username? customerDetails.username:
            '-'}}</h3>
          }
        </p-card>
      </div>
    </ng-container>
  </div>
  <div class="flex justify-content-end gap-3 mt-4">
    @if(loading){
    @if(operation == 'view') {
    <app-skeleton [id]="'form-fields'" [size]="{width:'4rem',height:'2rem'}"></app-skeleton>
    }
    @else{
    @for (i of [1,2]; track i) {
    <app-skeleton [id]="'form-fields'" [size]="{width:'4rem',height:'2rem'}"></app-skeleton>
    }
    }
    } @else{
    <p-button label="Cancel" severity="secondary" (onClick)="navigateToCustomerList()" />
    <p-button label="Update" *ngIf="operation === 'edit' && customerDetails"
      [disabled]="customerAdminForm.invalid || !isEmailValid || !customPhoneForm.valid || loading"
      (onClick)="updateCustomerAdminDetails()" />
    <p-button type="submit" *ngIf="operation === 'new' || !customerDetails" label="Continue"
      [disabled]="customerAdminForm.invalid || !isEmailValid || !customPhoneForm.valid || loading"
      (onClick)="addOrEditCustomerAdmin()" />
    }
  </div>
</form>
<p-toast />